import { usersRouteStore } from '../domain/store';
import { userUpsertModalRouteStore } from '../components/user-upsert-modal/domain/store';

export default () => {
  userUpsertModalRouteStore.setInitialState();
  usersRouteStore.setValue('activeUserId', null);
  usersRouteStore.setValue('showingUserUpsertModal', false);
};
